var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiMenu4Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFF6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4444 21.5625V23.75H7.22222V21.5625H19.4444ZM25 13.9062V16.0938H5V13.9062H25ZM22.7778 6.25V8.4375H10.5556V6.25H22.7778Z",
    fill: "#3A3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiMenu4Fill);
export default __webpack_public_path__ + "static/media/ri_menu-4-fill.9804df4e645358c2d88568ae998b7643.svg";
export { ForwardRef as ReactComponent };